import _wellKnownSymbol from "../internals/well-known-symbol";
import _iterators from "../internals/iterators";
var exports = {};
var wellKnownSymbol = _wellKnownSymbol;
var Iterators = _iterators;
var ITERATOR = wellKnownSymbol("iterator");
var ArrayPrototype = Array.prototype;

// check on default Array iterator
exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};
export default exports;